<template>
  <div class="overline">
    <span style="text-transform: none !important;">{{
      disaster.getDisasterName()
    }}</span>
    <span class="ml-3" v-if="disaster.getEmergencyClassName()">{{
      disaster.getEmergencyClassName()
    }}</span>
    <span class="ml-3" v-if="isGeClass()"> {{ getOilLevel() }}</span>
  </div>
</template>

<script>
import { ScreenId } from "@/js/value-objects/screen-id";
import handleError from "@/mixins/handle-error";
import cognito from "@/js/cognito";

const SCREEN_ID = ScreenId.SF0101;

export default {
  name: "LastDisaster",

  mixins: [handleError],

  computed: {
    disaster() {
      return this.$store.state.disasterInfo.latestDisaster;
    }
  },

  created() {
    this.initialize();
  },

  watch: {
    $route: "initialize"
  },

  methods: {
    initialize() {
      cognito
        .isAuthenticated()
        .then(async () => {
          await this.$store
            .dispatch("disasterInfo/loadLatestDisaster", SCREEN_ID)
            .catch(error => {
              this.handleError(error, SCREEN_ID, "error");
            });
        })
        .catch(() => {});
    },

    isGeClass() {
      return this.disaster.getEmergencyClassName() === "ＧＥ";
    },

    getOilLevel() {
      let maxOilLevel = this.disaster.getMaxOilLevel();
      if (maxOilLevel === "0") {
        maxOilLevel = "-";
      } else if (maxOilLevel === "9") {
        maxOilLevel = "解除";
      }
      return "OIL " + maxOilLevel;
    }
  }
};
</script>
